/**
 * Construye la URL de navegación a partir de una context card emitida por el agente.
 */
export function buildContextUrl(card) {
    const base = `/analizarpropiedad/${card.entity_id}/informe-detalle`;
    const hash = card.section ? `#${card.section}` : '';
    return card.entity_type === 'propiedad'
        ? `/propiedad/${card.entity_id}`
        : `${base}${hash}`;
}
